






















































import {Component, Vue} from "vue-property-decorator";
import EForm from "@/components/datatable/EForm.vue";
import Number from "@/components/inputs/Number.vue";
import TextField from "@/components/inputs/TextField.vue";
import ImageShow from "@/components/ImageShow.vue";
import ImageUpload from "@/components/inputs/ImageUpload.vue";

export class havale {
  bankName: String = "";
  bankBranchNo: String = "";
  bankBranchName: String = "";
  bankHesapNo: String = "";
  iban: String = "";
  ibanName: String = "";
}

@Component({
  components: {
    ImageUpload,
    ImageShow,
    EForm, Number, TextField
  }
})
export default class Havale extends Vue {
  action: string = "config/havale";
  item: havale = new havale();

  headers = [
    {text: "Banka Adı", value: "bankName"},
    {text: "Banka Şube Kodu", value: "bankBranchNo"},
    {text: "Banka Hesap No", value: "bankBranchName"},
    {text: "Banka Şube Adı", value: "bankHesapNo"},
    {text: "Hesap Sahibi", value: "ibanName"},
    {text: "İban", value: "iban"},
    {text: "Sil", value: "actions"},
  ];
  data: {
    items: havale[]
  } = {
    items: []
  };

  async get() {
    let response = await this.$http.get(this.action);
    this.data = response.data;
    //@ts-ignore
    this.data.items = JSON.parse(this.data.items);
  }

  created() {
    this.get();
  }

  async add() {
    this.data.items.push(this.item);
  }

  deleteItem(props: any) {
    const index = this.data.items.indexOf(props.item);
    this.data.items.splice(index, 1);
  }
};
